import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions, alertActions } from '_actions';

class DBIntField extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            changingTimeout: 0,
            hasChanges: false
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return { value: this.props.value };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.value !== prevProps.value ||
            this.props.field !== prevProps.field) {
            this.setState((state) => {
                return { value: this.props.value, hasChanges: false };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            value: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 2000)
        });
         if (!this.props.disabled && this.props.handleValueChange) {
            this.props.handleValueChange(event.target.value);
        }
    }

    saveValue() {
        let val = this.state.value;
        if ((typeof val === 'string' || val instanceof String) && val.startsWith('+')) {
            val = val.substring(1);
        }

        this.setState({
            value: val,
        });

        if (this.state.hasChanges === true) {
            if (this.state.value === '') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            } else if (isNaN(this.state.value)) {
                this.props.alertWarning('Input is invalid');
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (this.state.value.includes('.')) {
                this.props.alertWarning('No decimal places allowed.')
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (this.props.min !== undefined && this.props.min !== null && parseInt(this.state.value) < this.props.min) {
                this.props.alertWarning('The minimum value for this field is: ' + this.props.min);
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (this.props.max !== undefined && this.props.max !== null && parseInt(this.state.value) > this.props.max) {
                this.props.alertWarning('The maximum value for this field is: ' + this.props.max);
                this.setState({ value: this.props.value, hasChanges: false });
            } else {
                this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseInt(this.state.value));
            }

            if (this.props.onChange) {
                this.props.onChange(this.state.value);
            }
        }
        this.setState({ hasChanges: false });
    }

    handleOnBlur() {
        if (
            this.state.value !== '' &&
            (
                isNaN(this.state.value) ||
                this.state.value.toString().includes('.') ||
                (this.props.min && parseInt(this.state.value) < this.props.min) ||
                (this.props.max && parseInt(this.state.value) > this.props.max)

            )
        ) {
            this.setState({ value: this.props.value });
        }
        this.saveValue();
        clearTimeout(this.state.changingTimeout);

    }

    render() {
        return (
            <input
                className={this.props.className ? this.props.className : ''}
                type='text'
                min={this.props.min}
                max={this.props.max}
                title={this.props.title ? this.props.title : ''}
                onChange={this.handleValueChange}
                onBlur={this.handleOnBlur}
                value={this.state.value}
                disabled={this.props.disabled ? this.props.disabled : false} />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)

    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined
            && state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : ''
    };
}

const connectedDBIntField = connect(mapStateToProps, mapDispatchToProps)(DBIntField);
export { connectedDBIntField as DBIntField };